var _rect, _circle, _circle2, _circle3, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgAurora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "#F8FBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 132,
    r: 250,
    fill: "#C7E7FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014,
    cy: 112,
    r: 286,
    fill: "#DAD4FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 984,
    cy: 622,
    r: 290,
    fill: "#C8FFF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 118,
    width: 1056,
    height: 484,
    rx: 42,
    fill: "white",
    fillOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 565C189 503.667 356.5 495.167 502.5 539.5C648.5 583.833 907.5 604.833 1280 602.5V720H0V565Z",
    fill: "#D8F2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAurora);
export default __webpack_public_path__ + "static/media/bg-aurora.fc2553345a62522bd1f56d9329622e8f.svg";
export { ForwardRef as ReactComponent };